import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Header,
  Icon,
  Button,
  Loader,
  Select,
  Segment,
  Breadcrumb,
} from "semantic-ui-react";
import { GradeRegistrationTable } from "../../../components/Admin/AcademicManagement";
import { useAuth } from "../../../hooks";
import { Grade, AcademicCycle, Subject } from "../../../api";
import "./GradeRegistration.scss";

const gradeController = new Grade();
const academicCycleController = new AcademicCycle();
const subjectController = new Subject();

export function GradeRegistration() {
  const { accessToken } = useAuth();
  const { academicCycleId } = useParams();

  const [academicCycle, setAcademicCycle] = useState(null);
  const [grades, setGrades] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  // Load academic cycle
  useEffect(() => {
    (async () => {
      try {
        const response = await academicCycleController.getAcademicCycle(
          academicCycleId
        );
        setAcademicCycle(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]);

  // Load grades by level
  useEffect(() => {
    if (!academicCycle) return;
    (async () => {
      try {
        const response = await gradeController.getGradesByLevelId(
          academicCycle.levelId,
          accessToken,
        );
        const gradeOptions = [
          { key: "", value: "", text: "Selecciona un grado" },
          ...response.map((grade) => ({
            key: grade.id,
            value: grade.id,
            text: grade.name,
          })),
        ];
        setGrades(gradeOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycle, accessToken]);

  // Load subjects
  useEffect(() => {
    (async () => {
      try {
        const response = await subjectController.getSubjects(accessToken);
        const subjectOptions = [
          { key: "", value: "", text: "Selecciona una asignatura" },
          ...response.map((subject) => ({
            key: subject.id,
            value: subject.id,
            text: subject.name,
          })),
        ];
        setSubjects(subjectOptions);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  if (!academicCycle)
    return <Loader active inline="centered" content="Cargando..." />;

  return (
    <div className="grade-registration-page">
      <Header as="h2">
        <Icon name="clipboard list" />
        <Header.Content>
          Registro de Notas Literales
          <Header.Subheader>
            {academicCycle.Level?.name} - Año {academicCycle.name}
          </Header.Subheader>
        </Header.Content>
      </Header>

      <Segment className="grade-registration-page__filters">
        <div className="grade-registration-page__filter-row">
          <div className="grade-registration-page__filter-item">
            <Select
              className="edunova-select"
              clearable
              options={grades}
              value={selectedGrade}
              onChange={(_, data) => setSelectedGrade(data.value)}
              placeholder="Selecciona un grado"
            />
          </div>
          <div className="grade-registration-page__filter-item">
            <Select
              className="edunova-select"
              clearable
              options={subjects}
              value={selectedSubject}
              onChange={(_, data) => setSelectedSubject(data.value)}
              placeholder="Selecciona una asignatura"
            />
          </div>
        </div>
      </Segment>

      <GradeRegistrationTable
        academicCycleId={parseInt(academicCycleId)}
        gradeId={selectedGrade}
        subjectId={selectedSubject}
      />
    </div>
  );
}
